import { createFileRoute, redirect } from "@tanstack/react-router";

/** ALP-84: short / renamed URL → its page (see REDIRECTS in app/nav.ts). */
export const Route = createFileRoute("/_app/compose")({
  beforeLoad: () => {
    throw redirect({ to: "/content/compose", replace: true });
  },
});
